// extracted by mini-css-extract-plugin
module.exports = {"top-popup":"a10a3f92e9--top-popup--12Uss","appear":"a10a3f92e9--appear--3z6y0","error":"a10a3f92e9--error--3U3yb","close-outer":"a10a3f92e9--close-outer--XDDPP"};